var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientOnly',[_c('div',_vm._g({staticClass:"flex justify-center items-center"},_vm.$listeners),[_c('ImageZoom',_vm._b({staticClass:"base-image-zoomer pointer-events-none lg:pointer-events-auto"},'ImageZoom',_vm.$attrs,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }